import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FiCheck, FiHome, FiPhone, FiAlertCircle } from "react-icons/fi";
import "./AggregatorThankYou.css";

const SUPPORT_TEL = "+918800846929";

const AggregatorThankYou = () => {
  const [params] = useSearchParams();
  const status = String(params.get("status") || "1").trim();
  const isSuccess =
    status === "1" || status === "true" || status === "success";

  return (
    <main className={`fw-agg-ty ${isSuccess ? "is-success" : "is-fail"}`}>
      <section className="fw-agg-ty__card" aria-labelledby="fw-agg-ty-heading">
        {isSuccess ? (
          <>
            <div className="fw-agg-ty__icon-wrap" aria-hidden="true">
              <span className="fw-agg-ty__halo" />
              <div className="fw-agg-ty__icon">
                <FiCheck strokeWidth={3} />
              </div>
            </div>

            <p className="fw-agg-ty__badge">Application received</p>

            <h1 id="fw-agg-ty-heading" className="fw-agg-ty__title">
              Thank you
            </h1>

            <p className="fw-agg-ty__lead">
              Your loan application has been submitted successfully.
              <br />
              Our team will contact you shortly.
            </p>
          </>
        ) : (
          <>
            <div className="fw-agg-ty__icon-wrap" aria-hidden="true">
              <span className="fw-agg-ty__halo fw-agg-ty__halo--fail" />
              <div className="fw-agg-ty__icon fw-agg-ty__icon--fail">
                <FiAlertCircle strokeWidth={2.5} />
              </div>
            </div>

            <p className="fw-agg-ty__badge fw-agg-ty__badge--fail">
              Application pending
            </p>

            <h1 id="fw-agg-ty-heading" className="fw-agg-ty__title">
              We could not confirm
            </h1>

            <p className="fw-agg-ty__lead">
              Something went wrong while receiving your application.
              <br />
              Please try again or call support.
            </p>
          </>
        )}

        <div className="fw-agg-ty__actions">
          <Link to="/" className="fw-agg-ty__btn fw-agg-ty__btn--primary">
            <FiHome />
            Back to Home
          </Link>
          <a
            href={`tel:${SUPPORT_TEL}`}
            className="fw-agg-ty__btn fw-agg-ty__btn--ghost"
          >
            <FiPhone />
            Call Support
          </a>
        </div>
      </section>
    </main>
  );
};

export default AggregatorThankYou;
